import { render } from "./MWEventPresenters.vue?vue&type=template&id=20289c64"
import script from "./MWEventPresenters.vue?vue&type=script&lang=js"
export * from "./MWEventPresenters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__